// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Stepper_tabs__VJpEo","tab":"Stepper_tab__1Lm1N","active":"Stepper_active__1i3fw","passed":"Stepper_passed__jtHRh"};